import React, { useState } from 'react'
import {
    ReactCompareSlider,
    ReactCompareSliderImage,
} from 'react-compare-slider'

export default function Compare() {
    const [almoLoaded, setAlmoLoaded] = useState({
        first: false,
        second: false,
    })
    const [hsfLoaded, setHsfLoaded] = useState({
        first: false,
        second: false,
    })

    return (
        <>
            <div className="flex flex-col items-center gap-20 mt-5">
                <div>
                    <h2>Almo Vintage</h2>
                    <div
                        className={`w-full max-w-lg aspect-square flex justify-center items-center mt-4 duration-300 ${
                            almoLoaded.first && almoLoaded.second
                                ? 'opacity-100'
                                : 'opacity-0'
                        }`}
                    >
                        <ReactCompareSlider
                            itemOne={
                                <ReactCompareSliderImage
                                    src={require('../../img/compere/almo_before_1024.png')}
                                    alt="Almo rug before"
                                    onLoad={() => {
                                        setAlmoLoaded((prev) => ({
                                            ...prev,
                                            first: true,
                                        }))
                                    }}
                                />
                            }
                            itemTwo={
                                <ReactCompareSliderImage
                                    src={require('../../img/compere/almo_after_1024.png')}
                                    alt="Almo rug after"
                                    onLoad={() => {
                                        setAlmoLoaded((prev) => ({
                                            ...prev,
                                            second: true,
                                        }))
                                    }}
                                />
                            }
                            onlyHandleDraggable
                        />
                    </div>
                </div>
                <div>
                    <h2>HSF Systems</h2>
                    <div
                        className={`w-full max-w-lg aspect-square flex justify-center items-center mt-4 duration-300 ${
                            hsfLoaded.first && hsfLoaded.second
                                ? 'opacity-100'
                                : 'opacity-0'
                        }`}
                    >
                        <ReactCompareSlider
                            itemOne={
                                <ReactCompareSliderImage
                                    src={require('../../img/compere/hsf_systems_before_1024.png')}
                                    alt="Almo rug before"
                                    onLoad={() => {
                                        setHsfLoaded((prev) => ({
                                            ...prev,
                                            first: true,
                                        }))
                                    }}
                                />
                            }
                            itemTwo={
                                <ReactCompareSliderImage
                                    src={require('../../img/compere/hsf_systems_after_1024.png')}
                                    alt="Almo rug after"
                                    onLoad={() => {
                                        setHsfLoaded((prev) => ({
                                            ...prev,
                                            second: true,
                                        }))
                                    }}
                                />
                            }
                            onlyHandleDraggable
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
